
export default (formikProps) => {
	const getTouchedKeys = (values) => {
		const obj = Array.isArray(values) ? [] : {}

		for (let key in values) {
			const value = values[key];
			if (typeof value === 'object') {

				obj[key] = getTouchedKeys(value);
			} else {
				obj[key] = true;
			}
		}

		return obj;
	}

	const newTouchedObject = getTouchedKeys(formikProps.values);
	formikProps.setTouched(newTouchedObject)
}